/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton} from '@ion/dls/src/components/buttons/IconButton';
import {ColumnChooserIcon} from '@ion/dls/src/icons/ColumnChooserIcon';
import Tooltip from '../tooltip/Tooltip';

export const ColumnChooserTooltip = function(props) {
  return <Tooltip arrow {...props} />;
};

// defines the container props ...
export type ColumnChooserButtonProps = {
  onShowColumnChooser: (params?: boolean) => void
};

/**
 * The ColumnChooserButton provides the ColumnChooser Icon Button which provides the state
 * and labels common amongst the grid
 *
 * ```typescript
 *   import {ColumnChooserButton} from '@ion/dls/src/components/buttons/';
 *
 *   <ColumnChooserButton onShowColumnChooser={onShowColumnChooser} />
 * ```
 */
export const ColumnChooserButton = ({onShowColumnChooser}: ColumnChooserButtonProps) => {
  return (
    <ColumnChooserTooltip title={translate('common:columnChooser.title')}>
      <div>
        <IconButton icon={<ColumnChooserIcon />}
          onClick={onShowColumnChooser} />
      </div>
    </ColumnChooserTooltip>
  );
};

export default ColumnChooserButton;
